import {
  PICKED_ANSWER_FAIL,
  PICKED_ANSWER_RESET,
  PICKED_ANSWER_START,
  PICKED_ANSWER_SUCCESS,
} from './constants';
import {PickedAnswerActions, PickedAnswerState} from './types';

const initialState: PickedAnswerState = {
  loading: false,
  data: undefined,
  error: undefined,
};

const reducer = (
  state = initialState,
  action: PickedAnswerActions,
): PickedAnswerState => {
  switch (action.type) {
    case PICKED_ANSWER_START:
      return {
        ...initialState,
        loading: true,
      };
    case PICKED_ANSWER_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case PICKED_ANSWER_FAIL:
     return {
        ...state,
        loading: false,
        error: action.error,
      };
    case PICKED_ANSWER_RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducer;
